import {callEndpoint, HandlePagination, PaginatedResponse} from "./utils/requests";
import {Group} from "../models/Group";

export const getGroups = (page: number) =>
    callEndpoint<PaginatedResponse<Group>>(`/api/groups/?page=${page}`, "GET")